<!-- <div [formGroup]="SettingForm" class="one" fxLayout="column">
<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
  <mat-form-field class="a" appearance="outline" fxFlex="33" class="pr-1">
    <mat-label>Top Margin</mat-label>
    <input type="number" matInput>
    <mat-icon matSuffix class="secondary-text"></mat-icon>
  </mat-form-field>
  <mat-form-field class="a" appearance="outline" fxFlex="33" class="pr-1">
    <mat-label>Bottom Margin</mat-label>
    <input type="number" matInput>
    <mat-icon matSuffix class="secondary-text"></mat-icon>
  </mat-form-field>
  <mat-form-field class="a" appearance="outline" fxFlex="33">
    <mat-label>Address Padding </mat-label>
    <input type="number" matInput>
    <mat-icon matSuffix class="secondary-text"></mat-icon>
  </mat-form-field>
</div>
<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
  <mat-form-field appearance="outline" fxFlex="50" class="pr-1" >
    <mat-label>Font</mat-label>
    <mat-select name="CURRENCYSYMBOL" placeholder="Font">

      <mat-option>
        Calibri
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" fxFlex="50" >
    <mat-label>Font Size</mat-label>
    <mat-select name="CURRENCYSYMBOL" placeholder="Font Size">

      <mat-option>
        9pt
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
  <mat-form-field class="a" appearance="outline" fxFlex="50" class="pr-1">
    <mat-label>Tax Invoice</mat-label>
    <input type="text" matInput>
    <mat-icon matSuffix class="secondary-text"></mat-icon>
  </mat-form-field>
  <mat-form-field class="a" appearance="outline" fxFlex="50" >
    <mat-label>Receipt</mat-label>
    <input type="text" matInput>
    <mat-icon matSuffix class="secondary-text"></mat-icon>
  </mat-form-field>
</div>

<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
  <div fxFlex="50" class="pr-1">
    <mat-checkbox class="check_1" >Show unit price and quality</mat-checkbox>
  </div>
  <div fxFlex="50" >
    <mat-checkbox class="check_1" >Show payment adwise cut-away</mat-checkbox>
  </div>
</div>
<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mt-12">
  <div fxFlex="33" class="pr-1">
    <mat-checkbox class="check_1" >Show tax colum</mat-checkbox>
  </div>
  <div fxFlex="33" class="pr-1">
    <mat-checkbox class="check_1" >Show logo</mat-checkbox>
  </div>
  <div fxFlex="33">
    <mat-checkbox class="check_1" >Hide logo</mat-checkbox>
  </div>
</div>
<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="mt-12">
  <mat-form-field appearance="outline" fxFlex="33" class="pr-1" >
    <mat-label>Payment Service(Credit Card)</mat-label>
    <mat-select name="CURRENCYSYMBOL" placeholder="Payment Service(Credit Card)">

      <mat-option>
        Calibri
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" fxFlex="33" class="pr-1" >
    <mat-label>Payment Service(Paypal)</mat-label>
    <mat-select name="CURRENCYSYMBOL" placeholder="Payment Service(Paypal)">

      <mat-option>
        9pt
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" fxFlex="33" >
    <mat-label>Payment Service(Direct Debit)</mat-label>
    <mat-select name="CURRENCYSYMBOL" placeholder="Payment Service(Direct Debit)">

      <mat-option>
        9pt
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
  <mat-form-field class="a" appearance="outline" fxFlex="100" >
    <mat-label>Term & payment advice(Invoice & Statement)</mat-label>
    <textarea type="text" matInput></textarea>
    <mat-icon matSuffix class="secondary-text"></mat-icon>
  </mat-form-field>
</div>
<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
  <mat-form-field class="a" appearance="outline" fxFlex="100" >
    <mat-label>Terms(Quote)</mat-label>
    <textarea type="text" matInput></textarea>
    <mat-icon matSuffix class="secondary-text"></mat-icon>
  </mat-form-field>
</div>
<div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
  <div appearance="outline" fxFlex="50" >
    <label id="example-radio-group-label">Logo alignment</label>
    <mat-radio-group value="1" aria-label="Logo alignment" style="display: block;">
      <mat-radio-button value="1" class="mr-12">Left</mat-radio-button>
      <mat-radio-button value="2" class="mr-12">Center</mat-radio-button>
      <mat-radio-button value="3">Right</mat-radio-button>
    </mat-radio-group>
  </div>
  <div  appearance="outline" fxFlex="50">
    <label id="example-radio-group-label">Show taxes as</label>
    <mat-radio-group value="1" aria-label="Logo alignment" style="display: block;">
      <mat-radio-button value="1" class="mr-12">Exclusive</mat-radio-button>
      <mat-radio-button value="2">Inclusive</mat-radio-button>
    </mat-radio-group>
  </div>
</div>
</div> -->

@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div class="invoice-templatewrap one height-525">
  <mat-card class="invoice-templatecard p-6">
    <h2 class="mb-4 text-[20px]">Invoice Template Formats</h2>
    <ul class="invoice-templatelist">
      @for (val of invoiceTempData; track val; let i = $index) {
        <li
          (click)="InvoiceValueGet(val, i)"
          class="ml-6"
          [ngClass]="i == activeOption ? 'active' : ''"
        >
          {{ val.DESCRIPTION }}
        </li>
      }
    </ul>
  </mat-card>
  <div class="invoice-templatebtns">
    <button matButton="filled" (click)="newInvoicePopup('new')" class="text-center">New</button>
    <button matButton="filled" (click)="newInvoicePopup('edit')" class="text-center">Edit</button>
    <button matButton="filled" (click)="newInvoicePopup('duplicate')" class="text-center">
      Duplicate
    </button>
    <button matButton="filled" (click)="deleteInvoicePopup()" class="text-center">Delete</button>
  </div>
</div>
